'use client'

import React from 'react'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export default function PageContainer({ children, className = '', style }: PageContainerProps) {
  return (
    <div
      className={`min-h-full relative transition-none bg-[var(--brutal-paper)] ${className}`}
      style={{ backgroundColor: 'var(--brutal-paper)', ...style }}
    >
      {children}
    </div>
  )
}
